import 'common/types/globals/window';

export function getCookie(name: string): string {
  if (typeof window === `undefined`) {
    return ``;
  }

  const cookieStr = window.document.cookie;
  if (cookieStr.length > 0) {
    let start = cookieStr.indexOf(name + `=`);
    if (start !== -1) {
      start = start + name.length + 1;
      // django quotes cookies with "..." if they contain <>@,;:\"/[]?={} special chars
      if (cookieStr[start] === `"`) {
        start += 1;
      }

      let end = cookieStr.indexOf(`;`, start);
      if (end === -1) {
        end = cookieStr.length;
      }
      if (cookieStr[end - 1] === `"`) {
        end -= 1;
      }

      return unescape(cookieStr.substring(start, end));
    }
  }
  return ``;
}

function writeCookie(name: string, value: string, expireDays: number, crossSubdomain = false): void {
  if (!window.gdprData?.allowStorage) {
    return;
  }

  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + expireDays);
  const domainMatch = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i.exec(window.location.hostname);

  window.document.cookie = [
    `${name}=${escape(value)}`,
    expireDays === null ? `` : `expires=${expirationDate.toUTCString()}`,
    `path=/`,
    crossSubdomain && domainMatch ? `domain=.${domainMatch[0]}` : ``,
  ]
    .filter(Boolean)
    .join(`;`);
}

export async function safeSetCookie(
  name: string,
  value: string,
  expireDays: number,
  crossSubdomain = false,
): Promise<void> {
  if (window.gdprData) {
    await window.gdprData.waitUntilReady();
    writeCookie(name, value, expireDays, crossSubdomain);
  }
}
